import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import { diagnosticoMapper } from '../../helpers';

const getByAtencion = async ( tokenAtencion ) => {

  if( !tokenAtencion ){
    console.error('token atencion es requerido');
    return null
  }

  const query = `
    query AllAtenmedica($tokenAtencion:String) {
    allAtenmedica( tokenAtencion:$tokenAtencion ) {
        total
        status
        message
        atcm {
          id
          token
          diaganamSet{
            id
            estado
            diagnostico{
              id
              descripcion
              codigo
            }
            esprincipal
            tipoDiagnostico{
              id
              descripcion
            }
          }
        }
      }
    }
  `;

  const variables = {
    tokenAtencion
  };

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.allAtenmedica;

    if( response2.status !== 'success' ) {
      console.error('ocurrio un error', response2);
      return null
    }

    if( response2.atcm.length === 0 ) {
      console.log('no se encontraron diagnosticos',);
      return null;
    }

    if( response2.atcm[0].diaganamSet.length === 0 ) return null;

    const data = response2.atcm[0].diaganamSet;
    const dataMap = diagnosticoMapper( data );
    return dataMap;

  } catch (error) {
    console.error(error);
    return null;
  }
}


const multipleProcesos = async (params = {}) => {

  const { 
    diagnosticosToCreate, 
    diagnosticosToUpdate, 
    diagnosticosToDelete
  } = params;

  const query = `
    mutation ActualizarDiagnosticos(
      $diagnosticosToCreate:[DiagnosticoInput],
      $diagnosticosToUpdate:[DiagnosticoInput]
      $diagnosticosToDelete:[ID],
    ) {
      actualizarDiagnosticos(
        diagnosticosToCreate: $diagnosticosToCreate
        diagnosticosToUpdate: $diagnosticosToUpdate
        diagnosticosToDelete: $diagnosticosToDelete
      ) {
        status
        message
        createdIds
        updatedIds
        deletedIds
      }
    }
  `;

  const variables = {
    diagnosticosToCreate: diagnosticosToCreate || null,
    diagnosticosToUpdate: diagnosticosToUpdate || null,
    diagnosticosToDelete: diagnosticosToDelete || null
  };

  try{

    const response = await axios.post(rutas.axios + 'api', { query, variables });

    if(response.status !== 200) return null;
    const response2 = response.data.data.actualizarDiagnosticos;
    if(response2.status !== 'success') return null;

    const data = {
      diagnosticosCreated:  response2.createdIds,
      diagnosticosUpdated:  response2.updatedIds,
      diagnosticosDeleted:  response2.deletedIds
    }

    return data;

  }catch(error){
    console.error('Error al procesar los diagnosticos', error)
  }
}


const getByQuery = async ( querySearch ) => {

  if ( !querySearch )  return null;


  const query = `
    query getDiagnosticos($search: String!) { 
      getDiagnosticos(search: $search) {
        id
        descripcion
        codigo
      }
    }
  `;
  try {
    const response = await axios.post(rutas.axios + 'api', {
      query,
      variables: {
        search: querySearch
      }
    });
    
    return response.data.data.getDiagnosticos;
  } catch (error) {
    console.error("Error fetching Diagnostico", error);
  }
  
}

const getByQueryAll = async ( querySearch ) => {




  const query = `
    query getDiagnosticos($search: String!) { 
      getDiagnosticos(search: $search) {
        id
        descripcion
        codigo
      }
    }
  `;
  try {
    const response = await axios.post(rutas.axios + 'api', {
      query,
      variables: {
        search: querySearch
      }
    });
    
    return response.data.data.getDiagnosticos;
  } catch (error) {
    console.error("Error fetching Diagnostico", error);
  }
  
}


const getByQuerySelect = async ( querySearch ) => {

  if ( !querySearch ) return null;

  const diagnosticos = await getByQuery( querySearch );

  const diagnosticosOpts = diagnosticos.map(
    item => ({
      value: item.id,
      text: `(${item.codigo}) ${item.descripcion} `,
      codigo: item.codigo,
      descripcion : item.descripcion
    })
  );

  return diagnosticosOpts;

}

const getAll = async ( querySearch ) => {

 

  const diagnosticos = await getByQueryAll( querySearch );

  const diagnosticosOpts = diagnosticos.map(
    item => ({
      value: item.id,
      text: `(${item.codigo}) ${item.descripcion} `,
      codigo: item.codigo,
      descripcion : item.descripcion
    })
  );

  return diagnosticosOpts;

}


const getTiposSelect = async () => {
  const query = `
    query {
      allTipodiag {
        id
        descripcion
      }
    }
  `;
  try {
    const response = await axios.post(rutas.axios + "api", { query });
    return response.data.data.allTipodiag.map(
      (item) => ({
        value: item.id,
        text: item.descripcion,
      })
    );
  } catch (error) {
    console.error("Error getTipos diagnosticos:", error);
    return error;
  }
}


export const diagnosticosService = {
  getByAtencion,
  multipleProcesos,

  getTiposSelect,
  getByQuery,
  getByQuerySelect,
  getAll
}